<template>
  <div>
    <Form :isNewConfirmation="false" :controlIndex="controlIndex" />
  </div>
</template>

<script>
import Form from '../shared/Form.vue'

export default {
  components: {
    Form,
  },
  computed: {
    controlIndex() {
      return Number(this.$route.params.controlIndex)
    },
  },
}
</script>
